/**
 * Parse QR route to extract course name for preloading.
 * Matches: /qr/:course/:book/:lesson or /homework/qr/:course/:book/:lesson
 *
 * @param {string} pathname - The URL pathname
 * @returns {string|null} The course name or null if not a QR route
 */
export function getQRCourseName(pathname) {
  const match = pathname.match(/\/(?:homework\/)?qr\/([^/]+)\//);
  return match ? match[1] : null;
}

/**
 * True if a URL path parameter is the literal placeholder string JS produces
 * when a template literal interpolates a bad value (`${undefined}` →
 * "undefined"). Used by route guards to bail early on URLs like
 * /qr/phonics/b3/undefined or /courses/undefined that PostHog has surfaced
 * as broken pageviews from external shares (WeChat, browser history, etc.).
 *
 * @param {unknown} value
 * @returns {boolean}
 */
export function isPathParamPlaceholder(value) {
  return value === 'undefined' || value === 'null' || value === 'NaN';
}
